import React from 'react';
import './styles.scss';
import { connect } from 'react-redux';
import { UrbainUser } from '../../../redux/user/user.types';
import moment from 'moment';
import User from '../../../assets/User';

interface ProfilePersonalInfoSectionProps {
  urbainUser: UrbainUser;
}

const ProfilePersonalInfoSection = ({ urbainUser }: ProfilePersonalInfoSectionProps) => {
  return (
    <>
      {!!urbainUser && (
        <div className="__ProfilePersonalInfoSection">
          <div className="__details-section">
            <h6 className="__title">
              Legal name & Photo <span className="blue-text">*</span>
            </h6>
            <div className="d-flex align-items-center">
              <div className="__progile-image-wrapper position-relative">
                {urbainUser.PhotoURL && <img src={urbainUser.PhotoURL} alt="" className="position-absolute" />}
                {!urbainUser.PhotoURL && <User className="user-default-image position-absolute" />}
              </div>
              <p className="__details">
                {urbainUser.FirstName} {urbainUser.LastName}
              </p>
            </div>
          </div>
          <div className="__details-section">
            <h6 className="__title mb-2">I identify as...</h6>
            <p className="__details">{urbainUser.Pronoun}</p>
          </div>
          <div className="__details-section">
            <h6 className="__title mb-2">Date of birth</h6>
            <p className="__details">{urbainUser.DOB ? moment(urbainUser.DOB).format('MMMM D, YYYY') : '-'}</p>
          </div>
          <div className="__details-section">
            <h6 className="__title mb-2">
              Email address <span className="blue-text">*</span>
            </h6>
            <p className="__details">{urbainUser.Email}</p>
          </div>
          <div className="__details-section">
            <h6 className="__title mb-2">Phone number</h6>
            <p className="__details">
              {urbainUser.PhoneNumber ? '+' : ''}
              {urbainUser.PhoneNumber}
            </p>
          </div>
          <div className="__details-section">
            <h6 className="__title mb-2">Address</h6>
            <p className="__details">{urbainUser.ExtendedAddress ? urbainUser.ExtendedAddress : urbainUser.StreetAddress}</p>
          </div>
          <div className="__details-section">
            <h6 className="__title mb-2">Emergency contact</h6>
            <p className="__details">{urbainUser.EmergencyName}</p>
          </div>
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state: any) => ({
  urbainUser: state.user.urbainUser
});

export default connect(mapStateToProps)(ProfilePersonalInfoSection);
